import { render, staticRenderFns } from "./FormAsignacion.vue?vue&type=template&id=7046f67e&scoped=true"
import script from "./FormAsignacion.vue?vue&type=script&lang=js"
export * from "./FormAsignacion.vue?vue&type=script&lang=js"
import style0 from "./FormAsignacion.vue?vue&type=style&index=0&id=7046f67e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7046f67e",
  null
  
)

export default component.exports